import React from "react";
import CardPrimary from "../../component/Card/CardPrimary";
import Jumbotron from "../../component/Jumbotron";
import Text from "../../component/Text";

const cards = [
  {
    heading: "React select scrollable",
    linkUrl: "https://github.com/rajanlagah/react-select-scrollable",
    content:
      "Select tag that looks like apple scroll bar on mobile devices and normal select tag on desktop",
    tagList: ["Npm", "React"],
  },
  {
    heading: "React internet meter",
    linkUrl: "https://github.com/rajanlagah/react-internet-meter",
    content:
      "Component to run callback when internet speed get below given threshold value  ",
    tagList: ["Npm", "React"],
  },
  {
    heading: "Login boilerplate (React)",
    linkUrl:
      "https://github.com/5WebProjectChallenge/node-react-login-react-ts",
    content: "Started code of react with login/signup/logout graphql APIs ",
    tagList: ["React", "Typescript", "Graphql"],
  },
  {
    heading: "Login boilerplate (Node)",
    linkUrl: "https://github.com/5WebProjectChallenge/BasicAuth_server",
    content: "Started code of node with login/signup/logout graphql APIs",
    tagList: ["Typescript", "Node", "Graphql"],
  },
  {
    heading: "whitespace-se/storybook-addon-html",
    linkUrl: "https://github.com/whitespace-se/storybook-addon-html/pull/40",
    content: "https://github.com/whitespace-se/storybook-addon-html/pull/40",
    tagList: ["Storybook", "React"],
  },
  {
    heading: "CRUD app",
    linkUrl: "https://reddit.yogamonck.com/",
    content: "App for basic login and CRUD operations",
    tagList: ["Storybook", "React","Typescript", "Node", "Graphql"],
  },
];

const GithubPage = () => (
  <Jumbotron
    flexDirection="column"
    justifyContent="center"
    textAlign="center"
    minHeight="100vh"
    
  >
    <Text text="GITHUB" fs="60px" fontWeight="bold" />
    <Jumbotron height="70%" padding="100px 30px" width="100%"  >
      {cards.map((card) => (
        <CardPrimary key={card.heading} {...card} />
      ))}
    </Jumbotron>
  </Jumbotron>
);

export default GithubPage;
